import React from "react";
import "./Header.css";
import { Link } from "react-router-dom";
import SearchInput from "@material-ui/icons/Search";
import ShopingBasket from "@material-ui/icons/ShoppingBasket";
import amazonLogo from "./../../utils/image/logoOne.svg";
import { useStateValue } from "../StateProveder/State"
import {auth} from './../../BLL/Firebase'
function Header() {
  const [{ basket , user }] = useStateValue();
  const login = () => {
    auth.signOut()
  }
  return (
    <nav className="header">
      <Link to="/">
        <div>
          <img className="header_logo" src={amazonLogo} alt="" />
        </div>
      </Link>
      <div className="header_search">
        <input className="header_searchInput"></input>
        <SearchInput className="header_searchIcon"></SearchInput>
      </div>
      <div className="header_nav">
        <Link to={!user && '/login'} className="header_link">
          <div onClick={login} className="header_option">
            <span className="header_optionLineOne">Hello {user?.email}</span>
            <span className="header_optionLineTwo">{user ? 'Sign Out' : 'Sign In' }</span>
          </div>
        </Link>
        <Link to="/" className="header_link">
          <div className="header_option">
            <span className="header_optionLineOne">Retruns</span>
            <span className="header_optionLineTwo">& Orders</span>
          </div>
        </Link>
        <Link to="/" className="header_link">
          <div className="header_option">
            <span className="header_optionLineOne">Your</span>
            <span className="header_optionLineTwo">Prime</span>
          </div>
        </Link>
        <Link to="/checkout" className="header_link">
          <div className="header_optionBacket">
            <ShopingBasket />
            <span className="header_basketCount header_optionLineTwo">{basket?.length}</span>
          </div>
        </Link>
      </div>
    </nav>
  )
}

export default Header;
